// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screenfull-svg[data-v-29234bee] {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  fill: #5a5e66;\r\n  width: 25px;\r\n  height: 25px;\r\n  vertical-align: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
